import type { VisibilityState } from "@tanstack/react-table";
import { useMemo } from "react";
import { useTableViewOptions } from "@/components/custom/table/hooks/use-table-view-options";
import { gatewayColumns } from "./columns";

const MCP_GATEWAYS_VISIBILITY_STORAGE_KEY =
  "mcp-gateways-table-column-visibility-v2";

type GatewaysViewOptionsProps = {
  onVisibilityChange?: (
    visibility: VisibilityState,
    setter: (
      value: VisibilityState | ((val: VisibilityState) => VisibilityState)
    ) => void
  ) => void;
};

type GatewaysViewOptionsReturn = {
  columnVisibility: VisibilityState;
  setColumnVisibility: (
    value: VisibilityState | ((val: VisibilityState) => VisibilityState)
  ) => void;
  component: React.ReactElement;
};

export const useGatewaysViewOptions = ({
  onVisibilityChange,
}: GatewaysViewOptionsProps = {}): GatewaysViewOptionsReturn => {
  const columns = useMemo(() => gatewayColumns, []);

  return useTableViewOptions({
    columns,
    storageKey: MCP_GATEWAYS_VISIBILITY_STORAGE_KEY,
    onVisibilityChange,
    label: "Columns",
    className: "h-9 px-3 gap-2",
  });
};
